import React from 'react';
import PropTypes from "prop-types";
import clsx from "clsx";
import { useDispatch } from "react-redux";
import PrintIcon from '@material-ui/icons/Print';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ExcelIcon from '../../../assets/excelIcon.png'
import { lighten, makeStyles } from "@material-ui/core/styles";
import { Toolbar, Typography, Button, Tooltip, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { fetchCandidatosBaja, updateCandidatosBaja } from '../../../actions/candidatosBaja';

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    marginTop: 20,
  },
  highlight: theme.palette.type === "light" ?
    {
      color: theme.palette.secondary.main,
      backgroundColor: lighten(theme.palette.secondary.light, 0.85),
    } :
    {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.dark,
    },
  title: {
    flex: "1 1 100%",
  },
  formControl: {
    marginLeft: 20,
    marginRight: 20,
    minWidth: 250,
  },
  button: {
    width: 200,
  },
}));

export const TableToolbar = (props) => {
  const classes = useToolbarStyles();
  const dispatch = useDispatch();
  const { numSelected } = props;
  const categoriasFiltradas = props.categorias.filter(s => s.sp_datos !== '' && s.sp_datos !== null);

  const handleChangeTipo = e => {
    props.setIdMotivo(null);
    props.setIdTipo(e.target.value);
    dispatch(fetchCandidatosBaja(e.target.value, props.periodo));
  }
  const handleChangePeriodo = e => {
    props.setIdMotivo(null);
    props.setPeriodo(e.target.value);
    if (props.idTipo !== null)
      dispatch(fetchCandidatosBaja(props.idTipo, e.target.value));
  }

  const handleUpdate = () => {
    dispatch(updateCandidatosBaja(props.idTipo, props.periodo));
  }
  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected !== 1
            ? `${numSelected.toLocaleString()} registros seleccionados`
            : `${numSelected.toLocaleString()} registro seleccionado`
          }
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Candidatos a Bajas
        </Typography>
      )}
      <FormControl className={classes.formControl}>
        <InputLabel id="periodosSelectLabel">Cant Periodos Impagos</InputLabel>
        <Select
          labelId="periodosSelectLabel"
          id="periodosSelect"
          onChange={handleChangePeriodo}
        >
          <MenuItem key={1} value={1}>
            1
          </MenuItem>
          <MenuItem key={2} value={2}>
            2
          </MenuItem>
          <MenuItem key={3} value={3}>
            3
          </MenuItem>
        </Select>
      </FormControl>
      <FormControl className={classes.formControl}>
        <InputLabel id="categoriaSelectLabel">Tipo de afiliado</InputLabel>
        <Select
          labelId="categoriaSelectLabel"
          id="categoriaSelect"
          onChange={handleChangeTipo}
        >
          {categoriasFiltradas.map((t) => (
            <MenuItem key={t.id_sr} value={t.id_sr}>
              {t.descripcion_sr}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        variant="contained"
        color="secondary"
        className={classes.button}
        onClick={handleUpdate}
        disabled={props.idTipo === null}
      >
        Actualizar
      </Button>
      <Tooltip title="Imprimir">
        <Button
          onClick={props.handlePrint}
        >
          <PrintIcon fontSize="large" />
        </Button>
      </Tooltip>
      <Tooltip title="Exportar Pdf">
        <Button
          onClick={() => props.handleGeneratePdf(props.idTipo, props.periodo)}
        >
          <PictureAsPdfIcon fontSize="large" />
        </Button>
      </Tooltip>
      <Tooltip title="Exportar Excel">
        <Button
          style={{ marginRight: 15 }}
          onClick={() => props.handleExportExcel(props.idTipo, props.periodo)}
        >
          <img src={ExcelIcon} alt='excelIcon' style={{ height: 33 }}></img>
        </Button>
      </Tooltip>
      {numSelected > 0 ? (
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={props.handleSubmit}
        >
          Confirmar
        </Button>
      ) : null}
    </Toolbar>
  );
};

TableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};